/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskUpdate/Tags/Content/SearchResult/Empty"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let tagsPickerSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'tags_picker',
path: 'search_term',
})
let constantData = '+ Add'
let tagsPickerSearchTermValueData1 = fromData.useDataValue({ viewPath,
context: 'tags_picker',
path: 'search_term',
})
let constantData1 = 'as a new tag'
let aggregateData = fromAggregate.join(constantData, tagsPickerSearchTermValueData1, constantData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 width="100%"
 paddingLeft={0}
 paddingRight={0}
 height="auto"
 onClick={onClick}
>
{childProps => (
<fromFlow.When is={tagsPickerSearchTermValueData}>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="tags_picker.search_term"
 marginLeft={0}
 marginRight={0}
 data="'+ Add'"
 data="tags_picker.search_term"
 data="'as a new tag'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</fromFlow.When>
)}
</TysiaButton>
{children}
</React.Fragment>)
}